import { makeHook } from "../../utils/makeSingleArgHook";
import getHouseholds, { url } from "../requests/getHouseholds";
export const getHouseholdsKeyMaker = (queryParams) => {
    if (queryParams === null) {
        return [url(null)];
    }
    return [url(null), url(queryParams)];
};
const useGetHouseholds = makeHook(getHouseholds, getHouseholdsKeyMaker);
export default useGetHouseholds;
//# sourceMappingURL=useGetHouseholds.js.map